import { useEffect } from 'react';
import PropTypes from 'prop-types';
import SelectContact from 'Components/Organisms/SelectContact/SelectContact';
import { useFormContext, Controller } from 'react-hook-form';

export default function RHFSelectContact({ name, onChange, ...others }) {
    const { control, clearErrors } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => {
                const handleChange = (contactId, contact) => {
                    if (onChange) {
                        onChange(contactId, contact);
                    }
                    field.onChange(contactId);
                };

                useEffect(() => {
                    if (field.value && error) {
                        clearErrors(name);
                    }
                }, [name, field.value, clearErrors]);

                return <SelectContact {...field} error={error?.message} {...others} onChange={handleChange} />;
            }}
        />
    );
}

RHFSelectContact.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
};
